import createCache from '@emotion/cache';
const isBrowser = typeof document !== 'undefined';

// On the client side, the cache inserts after the last server-rendered
// <style data-emotion> tag, falling back to the emotion-insertion-point meta
// tag at the top of <head> when there is no critical CSS (client-only render).
// Inserting after the SSR styles lets a client style that differs from the
// server's — a global rule such as the CssBaseline body background under a
// color scheme restored from localStorage — win the cascade rather than lose
// to the earlier tag. MUI's styles still precede other styling solutions
// like CSS modules, so overriding MUI from those keeps working.
export function createEmotionCache() {
  let insertionPoint;
  if (isBrowser) {
    const ssrStyles = document.querySelectorAll<HTMLStyleElement>('style[data-emotion]');
    const emotionInsertionPoint = document.querySelector<HTMLMetaElement>('meta[name="emotion-insertion-point"]');
    insertionPoint = ssrStyles[ssrStyles.length - 1] ?? emotionInsertionPoint ?? undefined;
  }
  return createCache({
    key: 'css',
    insertionPoint
  });
}
export const emotionCache = createEmotionCache();